<template>
  <span>{{ count }}</span>
</template>

<script>
import moment from "moment";
export default {
  props: {
    samples: {
      type: Array,
      defautl: () => [],
    },
  },

  computed: {
    count() {
      return this.samples.filter((s) => {
        const finished = s.sample_status == 0 && s.submit_at;
        if (!finished) return false;
        const format = "YYYYMMDD";
        const dateInSample = moment(s.submit_at).format(format);
        const dateToday = moment().format(format);
        return dateInSample === dateToday;
      }).length;
    },
  },
};
</script>
